<template>
  <AppWithLoading :fetch="fetchData">
    <div v-if="operation === orderPlanOperations.UPGRADE">
      <OrderPlanSuccess :title="$t('paymentSuccess')" v-if="plan">
        {{ $t('upgradeSuccess',{plan: plan.title}) }}
      </OrderPlanSuccess>
    </div>
    <div v-else-if="operation === orderPlanOperations.RENEW">
      <OrderPlanSuccess :title="$t('paymentSuccess')">
        {{ $t('renewSuccess') }}
      </OrderPlanSuccess>
    </div>
    <div v-else-if="operation === orderPlanOperations.DOWNGRADE">
      <OrderPlanSuccess v-if="plan">
        {{ $t('downgradeSuccess',{plan: plan.title, date: expirationText}) }}
      </OrderPlanSuccess>
    </div>
    <div v-else-if="operation === orderPlanOperations.PROLONG">
      <OrderPlanSuccess :title="$t('prolongSuccess') " v-if="plan" />
    </div>
  </AppWithLoading>
</template>

<script>
import OrderPlanSuccess from '@/components/Payment/Order/Plan/OrderPlanSuccess';
import usePlan from '@/compositions/accounting/usePlan';
import { computed } from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';
import useSubscription from '@/compositions/accounting/useSubscription';
import useAccount from '@/compositions/accounting/useAccount';
import { orderPlanOperations } from '@/enums';

export default {
  name: 'OrderSuccess',
  components: { AppWithLoading, OrderPlanSuccess },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    operation: {
      type: String,
      required: true,
    },
  },
  setup({ id }) {
    const { getPlanById, fetchAll } = usePlan();
    const plan = computed(() => getPlanById(id));
    const { account, expirationText, fetch } = useAccount();

    const { isExpired } = useSubscription();

    const isSame = computed(() => account.value?.plan.id === id);
    const isNextSame = computed(() => account.value?.nextPlan?.id === id);

    async function fetchData() {
      await Promise.all([fetch(), fetchAll()]);
    }

    return {
      fetchData,
      plan,
      isExpired,
      isSame,
      isNextSame,
      expirationText,
      orderPlanOperations,
    };
  },
  computed: {
    showByRenew() {
      const { query } = this.$route;
      return !!(query.renew && query.renew === 'true');
    },
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
upgradeSuccess: Вы перешли на новый тариф
downgradeSuccess: Вы запланировали смену тарифа на «{plan}» с {date}
renewSuccess: Подписка возобновлена
paymentSuccess: Платёж прошел успешно
prolongSuccess: Продление подписки прошло успешно
</i18n>
<i18n lang="yml" locale="en">
upgradeSuccess: Plan upgraded
downgradeSuccess: Your plan will change to “{plan}” on {date}
renewSuccess: Subscription renewed
paymentSuccess: Payment was successful
prolongSuccess: Subscription prolongation was successful
</i18n>
